import { useTranslation } from "react-i18next";
import moment from "moment";
import { ResultLeague } from "./PeriodResultTable";

const headers = ["Kickoff Time", "Match", "Final"];

const finalScore = (score: string | undefined) => {
  const scores = score?.split(":").map((value) => value.trim()) ?? [];
  const hasScores = scores.length === 2 && scores.every((value) => value && value !== "-");
  if (!hasScores) {
    return "-";
  }

  return scores.join("-");
};

const HandballResultTable = ({ leagues }: { leagues: ResultLeague[] }) => {
  const { i18n, t } = useTranslation();
  const leaguesWithMatches = leagues.filter((league) => league.m.length > 0);

  return (
    <div className="handball-results-scroll">
      <table className="handball-results w-full">
        <thead>
          <tr>
            {headers.map((header) => <th key={header} scope="col">{t(header)}</th>)}
          </tr>
        </thead>
        {leaguesWithMatches.length === 0 && (
          <tbody>
            <tr>
              <td colSpan={headers.length} className="text-center">{t("No competition")}</td>
            </tr>
          </tbody>
        )}
        {leaguesWithMatches.map((league) => (
          <tbody key={league.k}>
            <tr>
              <th className="league text-left" scope="rowgroup" colSpan={headers.length}>
                {league.nn[i18n.language] ?? league.nn.en}
              </th>
            </tr>
            {league.m.map((match, index) => {
              const teams = match.n[i18n.language] ?? match.n.en;

              return (
                <tr key={match.k} className={index % 2 === 0 ? "odd-row" : "even-row"}>
                  <td className="handball-date">{moment(match.od).format("DD-MM-YYYY HH:mm")}</td>
                  <td className="handball-match"><b>{teams.h}</b> -vs- <b>{teams.a}</b></td>
                  <td className="handball-final">{finalScore(match.result?.summary?.totalScore)}</td>
                </tr>
              );
            })}
          </tbody>
        ))}
      </table>
    </div>
  );
};

export default HandballResultTable;
